import _ from 'lodash';
import {
  SMS_REQUEST_SENT,
  SMS_RESPONSE_RECEIEVED,
  SMS_SEND_FAILED,
} from '../constants/sms';

const initialState = {
  pending: [],
  received: [],
  failed: [],
};

export default function sms(state = initialState, action) {
  switch (action.type) {
    case SMS_REQUEST_SENT:
      return {
        ...state,
        pending: [...state.pending, { key: action.key }],
        failed: _.reject(state.failed, { key: action.key }),
      };
    case SMS_RESPONSE_RECEIEVED: {
      // payload will have key,data
      const { type, ...payload } = action;
      return {
        pending: _.reject(state.pending, { key: action.key }),
        received: [...state.received, { ...payload }],
        failed: _.reject(state.failed, { key: action.key }),
      };
    }
    case SMS_SEND_FAILED: {
      const duplicateFail = _.find(state.failed, { key: action.key });
      return {
        ...state,
        pending: _.reject(state.pending, { key: action.key }),
        failed: duplicateFail
          ? state.failed
          : [...state.failed, { ...action.payload, key: action.key }],
      };
    }
    default:
      return state;
  }
}
